var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "flex items-center py-3 justify-between border rounded",
      class: [_vm.warningClasses, _vm.lowPadding ? "px-3" : "px-6"],
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "flex items-center",
          class: [
            { "pe-8": _vm.showRightSlot },
            { "flex-grow justify-center": _vm.isContentCentered },
          ],
        },
        [
          _vm.showIcon
            ? _vm._t("icon", function () {
                return [
                  _vm.icon
                    ? _c("svg-icon", {
                        staticClass: "me-4 flex-shrink-0",
                        class: _vm.iconClasses,
                        attrs: { name: _vm.icon },
                      })
                    : _vm._e(),
                ]
              })
            : _vm._e(),
          _vm._t("default"),
        ],
        2
      ),
      _vm.showRightSlot
        ? _c(
            "div",
            { staticClass: "flex flex-wrap justify-end items-center" },
            [_vm._t("rightPart")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }